// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-cart{background:#fff;width:300px;height:auto;text-align:center;position:fixed;top:50%;margin-top:-50px;left:50%;margin-left:-100px;line-height:25px;z-index:100001;padding:15px}.modal-cart .close,.modal-cart .close:hover{cursor:pointer}.modal-bg{background-color:rgba(0,0,0,.2);opacity:.2;filter:alpha(opacity=20);zoom:1;position:fixed;top:0;bottom:0;left:0;right:0;z-index:100000}", ""]);
// Exports
module.exports = exports;
